import React from 'react';

import { TabularMeta_User } from '__generated__/TabularMeta_User';
import ContactMeta from './ContactMeta';

interface Props {
    brief: {
        id: string;
        designers: TabularMeta_User[];
        contacts: TabularMeta_User[];
    };
}

const Contacts: React.FunctionComponent<Props> = ({ brief }) => {
    return (
        <>
            <div className="contacts-drawer__item-list">
                {brief.contacts.map(designer => (
                    <div className="contacts-drawer__item" key={designer.id}>
                        <div className="contacts-drawer__meta-wrapper">
                            <ContactMeta designer={designer} brief={brief} />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Contacts;
